module.exports = "static/assets/4697d16ed8d86f5874aa33e44fb703e4.png";